import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "mappedValue"];
  static values = { mapping: Object, filled: Boolean };

  connect() {
    this.update();
  }

  update() {
    this.updateMappedValue();
    this.updateSliderFilling();
  }

  // Updates the field that holds the mapped value of the slider.
  // This is used when we transform the numerical value of the slider into something else.
  // E.g. values 1-5 can be mapped to text values "low" - "high"
  updateMappedValue() {
    if (this.hasMappedValueTarget && Object.keys(this.mappingValue).length > 0) {
      this.mappedValueTarget.value = this.mappingValue[this.inputTarget.value];
    }
  }

  // Updates the var that sets how much of the slider is filled
  updateSliderFilling() {
    if (this.filledValue) {
      this.inputTarget.style.setProperty("--slider-fill", `${this.fillPercent()}%`);
    }
  }

  fillPercent() {
    const { value, min, max } = this.inputTarget;
    const range = Number(max) - Number(min);
    if (range === 0) return 0;

    return ((Number(value) - Number(min)) / range) * 100;
  }
}
